<template>
    <Header></Header>
    <div class="container sub_page _report">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_01"><img src="img/report_left_01.png" /></i>
                <i class="deco_02 spin_blink1 _small"><img src="img/b_icon_03.png" /></i>
                <i class="deco_03 blink_zoom1 _xxsmall"><img src="img/b_icon_04.png" /></i>
                <i class="deco_04 blink_blink4 _xxxsmall"><img src="img/b_icon_04.png" /></i>
                <i class="deco_05 spin2 _medium"><img src="img/b_icon_03.png" /></i>
                <i class="deco_06 spin_blink3 _small"><img src="img/b_icon_01.png" /></i>
                <i class="deco_07 blink_zoom4 _small"><img src="img/b_icon_02.png" /></i>

                <i class="deco_character"><img src="img/report_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>시민제보창</h2>
            </div>
            <div class="sub_menu_tab wrap_1120">
                <button class="only_768" @click="subMenuTab" :class="{ active: state.subMenuOpen }">{{ state.subMenuName }}</button>
                <ul :class="{ active: state.subMenuOpen }">
                    <li @click="changeTab(1)"><a href="javascript:void(0)">성매매 의심 업소 제보</a></li>
                    <li @click="changeTab(2)" class="active"><a href="javascript:void(0)">성매매 알선 광고 제보</a></li>
                </ul>
            </div>
        </section>
        <section class="sub_page_con wrap_1120 report_area">
            <div class="bread_crumbs">
                <a href="" class="icon_wrap"><img src="img/home_icon.png" alt="홈" /></a>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="시민제보창" /></span>
                <a href="">시민제보창</a>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="성매매 의심 업소 제보" /></span>
                <a href="">성매매 알선 광고 제보</a>
                <span class="icon_wrap"><img src="img/part_icon.png" alt="신고하기" /></span>
                <a href="">신고하기</a>
            </div>
            <div class="sub_con_banner" v-if="state.step === 0">
                <div v-html="CommonUtils.decodeContent(state.menuContent)"></div>
                <div class="link con_list">
                    <p>시민제보 처리과정이 궁금하신가요? </p>
                    <router-link to="/faqList" @click="global.setIntroTab(3)" class="action_btn">
                        <span>과정 보러가기</span>
                        <img src="img/move_btn.png" alt="" />
                    </router-link>
                </div>
            </div>
            <template v-if="!state.isShowModal">
                <div class="part_tit">
                    <span>구분</span>
                    <span class="common_style">성매매 알선 광고 제보</span>
                </div>

                <template v-if="state.step === 0">
                    <div class="sub_page_con_view sign_form join con_write">
                        <div class="report_con" v-for="(form_state, index) in form_state_list" :key="index">
                            <ul>
                                <li style="justify-content: end">
                                    <div class="close_btn_wrap" v-if="form_state_list.length > 1">
                                        <button class="close_btn icon_wrap" @click="removeAd(index)">
                                            <img src="img/close_02.png" alt="닫기" />
                                        </button>
                                    </div>
                                </li>
                                <li class="checkbox_wrap">
                                    <span class="form_li_tit">분류</span>
                                    <label :for="'ad1_' + index">
                                        <input
                                            type="radio"
                                            :id="'ad1_' + index"
                                            :name="'ad_type_' + index"
                                            :checked="form_state.adType === 1"
                                            @click="form_state.adType = 1"
                                        />
                                        <em></em>
                                        <span>온라인 알선 광고</span>
                                    </label>

                                    <label :for="'ad2_' + index">
                                        <input
                                            type="radio"
                                            :id="'ad2_' + index"
                                            :name="'ad_type_' + index"
                                            :checked="form_state.adType === 2"
                                            @click="form_state.adType = 2"
                                        />
                                        <em></em>
                                        <span>지면광고</span>
                                    </label>

                                    <label :for="'ad3_' + index">
                                        <input
                                            type="radio"
                                            :id="'ad3_' + index"
                                            :name="'ad_type_' + index"
                                            :checked="form_state.adType === 3"
                                            @click="form_state.adType = 3"
                                        />
                                        <em></em>
                                        <span>불법옥외광고물</span>
                                    </label>

                                    <label :for="'ad4_' + index">
                                        <input
                                            type="radio"
                                            :id="'ad4_' + index"
                                            :name="'ad_type_' + index"
                                            :checked="form_state.adType === 4"
                                            @click="form_state.adType = 4"
                                        />
                                        <em></em>
                                        <span>기타</span>
                                    </label>
                                </li>

                                <!-- <li class="imp">
                                    <label for="title" class="form_li_tit">제목</label>
                                    <input id="title" type="text" v-model="form_state.title" placeholder="제목을 입력하세요" />
                                </li> -->

                                <li class="imp">
                                    <label for="area_name" class="form_li_tit">업소명</label>
                                    <input id="area_name" type="text" v-model="form_state.shopName" placeholder="업소명을 입력하세요" />
                                </li>
                                <li class="add_wrap imp">
                                    <label :for="'area_address_search' + index" class="form_li_tit">업소 주소</label>
                                    <input
                                        :id="'area_address_search' + index"
                                        v-model="form_state.zipCode"
                                        readonly
                                        type="text"
                                        class="code"
                                        placeholder="우편번호"
                                        @click="searchAddress(index)"
                                    />
                                    <button class="blue_btn" type="button" @click="searchAddress(index)">검색</button>

                                    <input id="area_address" v-model="form_state.addr" readonly type="text" class="text" placeholder="주소" />
                                    <input id="area_address2" v-model="form_state.addrDetail" type="text" placeholder="상세주소" />
                                </li>
                                <li class="">
                                    <label for="area_num" class="form_li_tit">업소 번호</label>
                                    <input id="area_num" v-model="form_state.shopNumber" type="text" placeholder="업소 번호를 입력하세요" />
                                </li>
                                <li class="checkbox_wrap">
                                    <label for="area_url" class="form_li_tit">광고 URL</label>
                                    <input id="area_url" v-model="form_state.adUrl" type="text" placeholder="광고 URL을 입력하세요" />
                                </li>
                                <li class="imp">
                                    <label for="area_num" class="form_li_tit">내용</label>
                                    <textarea
                                        class="custom_scroll"
                                        name=""
                                        id=""
                                        placeholder="성매매 의심 정황 : ‘성매매 알선 광고’로 의심되는 정황이 있다면 자세히 적어주세요."
                                        v-model="form_state.content"
                                    ></textarea>
                                </li>
                                <li class="file_wrap">
                                    <span class="form_li_tit">첨부</span>
                                    <label :for="'area_file' + index">
                                        <input
                                            :id="'area_file' + index"
                                            type="file"
                                            placeholder=""
                                            accept="image/*"
                                            multiple
                                            @change="(event) => handleFiles(event, form_state)"
                                        />
                                        <template v-if="!state.isMobile">
                                            <div class="file_box_wrap">‘파일첨부’ 버튼을 클릭하여 첨부해주세요</div>
                                            <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                                            <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                                        </template>
                                        <template v-else>
                                            <p class="p_info">200M 이하 JPG, PNG 파일을 첨부해주세요.</p>
                                            <span class="blue_btn" style="display: flex; justify-content: center; align-items: center">파일첨부</span>
                                        </template>
                                    </label>
                                    <div class="file_list">
                                        <div class="file" v-for="(item, idx) in form_state.file" :key="idx">
                                            <span class="file_name" @click="downloadFile(item.file, item.imgRealName)">{{ item.imgRealName }}</span>
                                            <button class="file_del icon_wrap" @click="fileRemove(item.idx)">
                                                <img src="img/close_02.png" alt="" />
                                            </button>
                                        </div>

                                        <div class="file" v-for="(item, index) in form_state.localFile" :key="index">
                                            <span class="file_name">{{ item.name }}</span>
                                            <button class="file_del icon_wrap" @click="removeNewFile(form_state.localFile, index)">
                                                <img src="img/close_02.png" alt="" />
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="btn_wrap _default left_right_btn _1_2">
                        <div class="left">
                            <button class="common_btn w_120" v-if="state.idx === 0" @click="addShop">+업소추가</button>
                        </div>
                        <div class="right">
                            <button class="common_btn _gray w_120" @click="router.replace('/report?type=2')">목록</button>
                            <button class="common_btn _gray w_120" @click="router.go(-1)">취소</button>
                            <button class="common_btn w_120" @click="moveStep(1)">다음</button>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="sub_page_con_view sign_form join">
                        <div class="report_con">
                            <ul>
                                <li v-if="state.idx === 0">
                                    <label for="user_nickname" class="form_li_tit">제보자 닉네임</label>
                                    <input
                                        id="user_nickname"
                                        v-model="state.nickName"
                                        type="text"
                                        placeholder="작성하지 않을 경우 익명으로 표기됩니다."
                                    />
                                </li>
                                <li class="imp">
                                    <label for="user_pw" class="form_li_tit">비밀번호</label>
                                    <input id="user_pw" v-model="state.pw" type="password" placeholder="비밀번호를 입력하세요" />
                                    <p class="p_info" v-if="state.pw.length < 6">비밀번호는 최소 6자 이상 입력해주세요.</p>
                                </li>
                            </ul>
                        </div>

                        <div class="con_info_view">
                            <div class="con_tit">센터 지원 안내</div>
                            <div class="con_desc">
                                다시함께상담센터는 성매매 과정에서 겪은 다양한 어려움과 피해를 함께 나누고, 해결할 수 있도록 돕는 전문 기관입니다. 
                                <br />
                                법률적 문제부터 심리·정서적인 어려움, 건강 회복까지 상황에 맞는 맞춤형 지원을 제공합니다. 
                                <br />
                                모든 상담 내용은 비밀보장되며 지원은 무료입니다. 이용자의 선택과 권리를 가장 우선으로 생각하며, 상담을 통해 지원
                                방향을 함께 결정합니다.
                                <br />
                                필요하실 때 언제든지 다시함께상담센터가 곁에 있겠습니다.
                            </div>
                            <div class="con_info">
                                <p>
                                    <span>
                                        <img src="img/call_icon.png" alt="" />
                                        전화번호
                                    </span>
                                    <a href="tel:02-814-3660" class="blue_txt">02-814-3660 (09:00~18:00)</a>
                                </p>
                                <p>
                                    <span>
                                        <img src="img/talk_icon.png" alt="" />
                                        카카오톡 채널
                                    </span>
                                    <a href="https://pf.kakao.com/_xguxaku" class="blue_txt">다시함께상담센터 (09:00~18:00)</a>
                                </p>
                                <p>
                                    <span>
                                        <img src="img/link_icon.png" alt="" />
                                        홈페이지 상담 게시판
                                    </span>
                                    <a href="http://dasi.or.kr/html/consult/consult.php" target="_blank" class="blue_txt">
                                        http://dasi.or.kr/html/consult/consult.php
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="btn_wrap _default left_right_btn _1_2">
                        <div class="left">
                            <!-- <button class="common_btn w_120">+업소추가</button> -->
                        </div>
                        <div class="right">
                            <button class="common_btn _gray w_120" @click="router.replace('/report?type=2')">목록</button>
                            <button class="common_btn _gray w_120" @click="moveStep(0)">이전</button>
                            <button class="common_btn w_120" @click="save" :disabled="!state.isPossible">저장</button>
                        </div>
                    </div>
                </template>
            </template>
        </section>
    </div>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        reactive,
        globalStore,
        userStore,
        onMounted,
        watch,
        useRoute,
        Header,
        Footer,
        router,
        apiService,
        types,
        ModalDefault,
        ref,
        CommonUtils,
        onBeforeMount,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault },
        setup() {
            const route = useRoute();
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                tab: 0 as number,
                step: 0 as number,
                idx: 0 as number,

                menuContent: "" as string,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isAuth: false,
                file: [] as Array<File>,
                isNoRedirect: false,

                nickName: "",
                pw: "",

                subMenuOpen: false as boolean,
                subMenuName: "성매매 알선 광고 제보" as string,

                isMobile: false,
                isPossible: true,
            });

            const form_state = reactive({
                idx: 0 as number,
                adType: 1 as 1 | 2 | 3 | 4 | null,
                shopName: "" as string,
                zipCode: "" as string,
                addr: "" as string,
                addrDetail: "" as string,
                shopNumber: "" as string,
                isSchool: 0 as number,
                schoolName: "" as string,
                // title: "" as string,
                content: "" as string,
                file: [] as Array<types.ResReportFileVOForApi>,
                localFile: [] as Array<File>,
                nickName: "" as string,
                adUrl: "" as string,
                pw: "" as string,

                sido: "" as string,
                sigungu: "" as string,
                dong: "" as string,
                lat: 0 as number,
                lng: 0 as number,
            });

            const form_state_list = reactive<Array<typeof form_state>>([
                {
                    idx: 0,
                    adType: 1 as 1 | 2 | 3 | 4,
                    shopName: "",
                    zipCode: "",
                    addr: "",
                    addrDetail: "",
                    shopNumber: "",
                    isSchool: 0,
                    schoolName: "",
                    // title: "",
                    content: "",
                    file: [],
                    nickName: "",
                    adUrl: "",
                    pw: "",
                    localFile: [],

                    sido: "",
                    sigungu: "",
                    dong: "",
                    lat: 0,
                    lng: 0,
                },
            ]);

            onMounted(() => {
                state.isAuth = false;
                const idx = Number(route.params.id);
                if (route.params.id) {
                    if (idx && typeof idx === "number" && !isNaN(idx)) {
                        state.idx = idx;

                        if (user.isLogin()) {
                            if (
                                !(
                                    user.isLogin() &&
                                    (user.userInfo.gubun === 1 ||
                                        (user.userInfo.isAdmin &&
                                            user.roles != null &&
                                            user.roles.some((item: types.RoleVO) => item.key.indexOf("ad") > -1)))
                                )
                            ) {
                                confirmModal();
                            } else {
                                state.isAuth = true;
                                getDetail();
                            }
                        } else {
                            confirmModal();
                        }
                    } else {
                        router.back();
                    }
                }

                getMenuTitle();

                state.isMobile = window.innerWidth < 768;
            });

            const confirmModal = () => {
                state.modalTab = 3;
                state.modalTitle = "알림";
                state.modalContent = "제보 시 설정한 비밀번호를 입력해 주세요.";
                state.isShowModal = true;
            };

            const getDetail = async () => {
                const res = await apiService.report.detail(state.idx);

                if (res.returnCode === 0) {
                    if (res.data.meIdx === user.userInfo.idx || state.isAuth) {
                        const data: types.ResReportVOForApi = res.data;
                        form_state.idx = data.idx;
                        form_state.adType = data.adType;
                        form_state.shopName = data.shopName;
                        form_state.zipCode = data.zipCode;
                        form_state.addr = data.address;
                        form_state.addrDetail = data.addressDetail;
                        form_state.shopNumber = data.number;
                        form_state.isSchool = data.isSchool;
                        form_state.schoolName = data.schoolName;
                        form_state.content = data.content;
                        form_state.file = data.fileList;
                        form_state.nickName = data.nickname;
                        form_state.adUrl = data.adUrl;

                        form_state_list[0] = form_state;
                    } else if (res.data.meIdx === 0) {
                        state.modalTab = 3;
                        state.modalTitle = "알림";
                        state.modalContent = "제보 시 설정한 비밀번호를 입력해 주세요.";
                        state.isShowModal = true;
                    }
                } else if (res.returnCode === 11) {
                } else {
                    console.error(res.description);
                }
            };

            const getMenuTitle = async () => {
                const res = await apiService.report.menuDetail(2);
                if (res.returnCode === 0) {
                    state.menuContent = res.data.headerTitle;
                } else if (res.returnCode === 11) {
                } else {
                    console.error(res.description);
                }
            };

            const changeTab = (tab: number) => {
                global.setReportTab(tab);
                router.push("/report?type=" + tab);
                state.subMenuOpen = false;
                switch (tab) {
                    case 1:
                        state.subMenuName = "성매매 의심 업소 제보";
                        break;
                    case 2:
                        state.subMenuName = "성매매 알선 광고 제보";
                        break;
                }
            };

            const subMenuTab = () => {
                if (window.innerWidth <= 768) {
                    state.subMenuOpen = !state.subMenuOpen;
                }
            };

            const moveStep = (step: number) => {
                let isValid = true;
                for (const form of form_state_list) {
                    if (!isValidCheck(form)) {
                        isValid = false;
                    }
                }

                if (isValid) {
                    state.step = step;
                }
            };

            const searchAddress = async (index: number) => {
                new window.daum.Postcode({
                    oncomplete: (data: any) => {
                        try {
                            form_state_list[index].zipCode = data.zonecode;
                            form_state_list[index].addr = data.address;

                            form_state_list[index].sido = data.sido;
                            form_state_list[index].sigungu = data.sido + " " + data.sigungu;
                            form_state_list[index].dong = data.sido + " " + data.sigungu + " " + data.bname;

                            // const geocoder = new window.daum.maps.services.Geocoder();
                            // if (geocoder) {
                            //     geocoder.addressSearch(data.address, (result: any, status: any) => {
                            //         if (status === window.daum.maps.services.Status.OK) {
                            //             form_state_list[index].lat = result[0].y;
                            //             form_state_list[index].lng = result[0].x;
                            //         } else {
                            //             console.error("주소 변환 실패", status);
                            //         }
                            //     });
                            // }
                        } catch (err) {
                            console.error(err);
                        }
                    },
                }).open();
            };

            const fileRemove = async (idxFile: number) => {
                const res = await apiService.report.removeFile(form_state.idx, idxFile);
                if (res.returnCode === 0) {
                    const index = form_state.file.findIndex((item) => item.idx === idxFile);
                    if (index !== -1) {
                        form_state.file.splice(index, 1);
                    }
                } else if (res.returnCode === 11) {
                } else {
                    console.error(res.description);
                }
            };

            const downloadFile = async (fileUrl: string, fileName: string) => {
                const res = await fetch(fileUrl);
                const blob = await res.blob();
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                URL.revokeObjectURL(link.href);
            };

            const closeModal = () => {
                state.isShowModal = false;
                if (state.modalTab === 3) {
                    router.replace({ name: "AdView", params: { id: state.idx } });
                } else if (state.idx > 0) {
                    // router.replace({ name: "AdView", params: { id: state.idx } });
                    router.go(-1);
                } else if (!(state.idx > 0) && state.modalTab === -1) {
                    // router.replace("/report?type=2");
                    router.go(-1);
                }

                state.isAuth = false;
                state.isNoRedirect = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "checkPw") {
                    getConfirm(param.pw);
                } else if (param.action === "callback") {
                    router.replace("/report?type=2");
                    // if (state.idx > 0 && form_state_list.length > 1) {
                    //     router.replace("/report");
                    // } else if (state.idx > 0) {
                    //     router.replace({ name: "AreaView", params: { id: state.idx } });
                    // } else {
                    //     router.replace("/report");
                    // }
                }
            };

            const getConfirm = async (pw: string) => {
                const param: types.ReqConfirmPw = {
                    idx: state.idx,
                    pw: pw,
                };
                const res = await apiService.report.confirmPw(param);
                if (res.returnCode === 0) {
                    state.isShowModal = false;
                    state.isAuth = true;
                    form_state.pw = param.pw;
                    getDetailWithPw(pw);
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 22) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    console.error(res.description);
                    router.back();
                }
            };

            const getDetailWithPw = async (pw: string) => {
                const param: types.ReqConfirmPw = {
                    idx: state.idx,
                    pw: pw,
                };

                const res = await apiService.report.confirmDetail(param);
                if (res.returnCode === 0) {
                    const data: types.ResReportVOForApi = res.data;
                    form_state.idx = data.idx;
                    form_state.adType = data.adType;
                    form_state.shopName = data.shopName;
                    form_state.zipCode = data.zipCode;
                    form_state.addr = data.address;
                    form_state.addrDetail = data.addressDetail;
                    form_state.shopNumber = data.number;
                    form_state.isSchool = data.isSchool;
                    form_state.schoolName = data.schoolName;
                    form_state.content = data.content;
                    form_state.file = data.fileList;
                    form_state.nickName = data.nickname;
                    form_state.adUrl = data.adUrl;

                    form_state_list[0] = form_state;
                } else if (res.returnCode === 11) {
                } else if (res.returnCode === 22) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "비밀번호가 일치하지 않습니다.";
                    state.isShowModal = true;
                } else {
                    console.error(res.description);
                    router.back();
                }
            };

            const isValidCheck = (param: typeof form_state): boolean => {
                let isConfirm = true;
                if (!param.shopName) {
                    state.modalTab = 8;
                    state.modalTitle = "안내";
                    state.modalContent = "업소명을 입력해 주세요.";
                    state.isShowModal = true;

                    isConfirm = false;
                } else if (!(param.zipCode && param.addr && param.addrDetail)) {
                    state.modalTab = 8;
                    state.modalTitle = "안내";
                    state.modalContent = "주소를 입력해 주세요.";
                    state.isShowModal = true;

                    isConfirm = false;
                }
                //  else if (!param.shopNumber) {
                //     state.modalTab = 8;
                //     state.modalTitle = "안내";
                //     state.modalContent = "업소 번호를 입력해 주세요.";
                //     state.isShowModal = true;

                //     isConfirm = false;
                //     // } else if (!param.adUrl) {
                //     // state.modalTab = 8;
                //     // state.modalTitle = "안내";
                //     // state.modalContent = "광고 URL을 입력해 주세요.";
                //     // state.isShowModal = true;

                //     // isConfirm = false;
                // }
                else if (param.adType == null || param.adType > 4 || param.adType < 1) {
                    state.modalTab = 8;
                    state.modalTitle = "안내";
                    state.modalContent = "분류를 선택해주세요.";
                    state.isShowModal = true;

                    isConfirm = false;
                } else if (!param.content) {
                    state.modalTab = 8;
                    state.modalTitle = "안내";
                    state.modalContent = "내용을 입력해 주세요.";
                    state.isShowModal = true;

                    isConfirm = false;
                }

                return isConfirm;
            };

            const save = async () => {
                state.isPossible = false;
                let isConfirm = true;
                let isMoveStep = 0;

                if (!(state.idx > 0)) {
                    if (state.pw.length < 6) {
                        state.modalTab = 8;
                        state.modalTitle = "안내";
                        state.modalContent = "비밀번호를 6자리 이상 입력해주세요.";
                        state.isShowModal = true;
                        state.isPossible = true;
                        return;
                    }
                }

                for (const form of form_state_list) {
                    isConfirm = isValidCheck(form);
                }

                if (!isConfirm) {
                    if (isMoveStep === 0) moveStep(0);
                    state.isPossible = true;
                    return;
                }

                let isSuccess = true;
                if (isConfirm === true) {
                    if (!(state.idx > 0)) {
                        for (const form of form_state_list) {
                            if (isSuccess) {
                                const param: types.ReqReport = {
                                    type: 2,
                                    shopName: form.shopName,
                                    adType: form.adType,
                                    zipCode: form.zipCode,
                                    addr: form.addr,
                                    addrDetail: form.addrDetail,
                                    shopNumber: form.shopNumber,
                                    url: form.adUrl,
                                    isSchool: form.isSchool,
                                    schoolName: form.schoolName,
                                    // title: form.title,
                                    content: form.content,
                                    file: form.localFile,
                                    nickName: state.nickName ? state.nickName : "익명",
                                    pw: state.pw,

                                    sido: "",
                                    sigungu: form.sigungu,
                                    dong: form.dong,
                                    lat: form.lat,
                                    lng: form.lng,
                                };

                                const res = await apiService.report.add(param);
                                if (res.returnCode !== 0) {
                                    console.error(res.description);
                                    isSuccess = false;
                                }
                            }
                        }
                    } else {
                        for (const form of form_state_list) {
                            if (isSuccess) {
                                const param: types.ReqReportForModify = {
                                    idx: form.idx,
                                    shopName: form.shopName,
                                    adType: form.adType,
                                    zipCode: form.zipCode,
                                    addr: form.addr,
                                    addrDetail: form.addrDetail,
                                    shopNumber: form.shopNumber,
                                    url: form.adUrl,
                                    isSchool: form.isSchool,
                                    schoolName: form.schoolName ? form.schoolName : "",
                                    // title: form.title,
                                    content: form.content,
                                    pw: state.pw,
                                    file: form.localFile,

                                    sido: "",
                                    sigungu: form.sigungu,
                                    dong: form.dong,
                                    lat: form.lat,
                                    lng: form.lng,
                                };

                                const res = await apiService.report.modify(param);
                                if (res.returnCode !== 0) {
                                    console.error(res.description);
                                    isSuccess = false;
                                }
                            }
                        }
                    }
                }

                if (isSuccess) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    if (!(state.idx > 0)) {
                        state.modalContent = "제보글이 등록되었습니다.";
                    } else {
                        state.modalContent = "제보글이 수정되었습니다.";
                    }
                    state.isShowModal = true;
                    state.isPossible = true;
                } else if (!isSuccess && isConfirm) {
                    state.modalTab = 8;
                    state.modalTitle = "알림";
                    state.modalContent = "저장 실패하였습니다.";
                    state.isShowModal = true;
                    state.isPossible = true;
                }
            };

            const handleFiles = (e: any, item: any) => {
                const target = e.target as HTMLInputElement;
                const files = Array.from(e.target.files);
                if (!files.length) return;

                const isFiles = files.filter((file: any) => !file.type.startsWith("image/"));

                if (isFiles.length > 0) {
                    state.modalTab = 8;
                    state.modalTitle = "안내";
                    state.modalContent = "이미지 파일만 첨부할 수 있습니다.";
                    state.isShowModal = true;
                    e.target.value = "";
                    return;
                }
                item.localFile = files;
                target.value = "";
            };

            const removeNewFile = (item: any, index: number) => {
                item.splice(index, 1);
            };

            const addShop = () => {
                if (form_state_list.length >= 5) {
                    state.modalTab = 8;
                    state.modalTitle = "안내";
                    state.modalContent = "업소는 최대 5개까지만 등록 가능합니다.";
                    state.isNoRedirect = true;
                    state.isShowModal = true;
                    return;
                } else {
                    form_state_list.push({
                        idx: 0,
                        adType: 1,
                        shopName: "",
                        zipCode: "",
                        addr: "",
                        addrDetail: "",
                        shopNumber: "",
                        isSchool: 0,
                        schoolName: "",
                        // title: "",
                        content: "",
                        file: [],
                        nickName: "",
                        adUrl: "",
                        pw: "",
                        localFile: [],

                        sido: "",
                        sigungu: "",
                        dong: "",
                        lat: 0,
                        lng: 0,
                    });
                }
            };

            const removeAd = (index: number) => {
                form_state_list.splice(index, 1);
            };

            return {
                state,
                form_state,
                changeTab,
                subMenuTab,
                moveStep,
                searchAddress,
                fileRemove,
                downloadFile,
                closeModal,
                callBackModal,
                router,
                save,
                handleFiles,
                removeNewFile,
                global,
                form_state_list,
                addShop,
                removeAd,
                CommonUtils,
            };
        },
    };
</script>
<style scoped>
    .right button {
        margin-left: 10px;
    }

    .report_con ul {
        position: relative;
    }

    .close_btn_wrap {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;
    }

    .close_btn {
        background: none;
        border: none;
        cursor: pointer;
    }

    input[readonly] {
        background-color: #f5f5f5;
    }
</style>
